module.exports = __webpack_public_path__ + "static/media/Success.cbb7b1f6.svg";